
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/l/[governorate]/k/[q]",
      function () {
        return require("private-next-pages/listing/l/[governorate]/k/[q]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/l/[governorate]/k/[q]"])
      });
    }
  